<template>
  <div v-if="visible"></div>
</template>

<script>
import {
  w
} from '../utils/helpers'

// import 'hellojs/src/modules/facebook'
// import 'hellojs/src/modules/google'
// import hello from 'hellojs/dist/hello.all'

export default {
  created() {

    const d = document
    let head = d.head || d.getElementsByTagName('head')[0]
    let s = d.createElement("script")
    let v = this
    s.src = '../vendor/hello.all.js'
    s.setAttribute("crossorigin","anonymous")
    s.onload = s.onreadystatechange = function() {
      if (!this.readyState || /loaded|complete/.test(this.readyState)) {
        v.init()
        s.onload = s.onreadystatechange = null
        if (s.parentNode)
          s.parentNode.removeChild(s)
        s = null
      }
    }
    head.insertBefore(s, head.firstChild);

  },
  methods: {
    init() {

      hello.init({
      	facebook: '@@facebookToken',
      	google: '@@googleToken'
      },{
        redirect_uri: '//@@CDN/assets/html/app.html?mode=social',
        state: JSON.stringify({
          orgId: w.orgId,
          widgetId:w.widgetId
        })
      })

      hello.on('auth.login', this.login)
      hello.on('auth.logout', this.logout)

      window.addEventListener('message', this.listen)

      //temporary handle hellojs unhandling of errors
      window.addEventListener('unhandledrejection', (e,p)=>{
        if (e.reason &&
          e.reason.error &&
          ['access_denied','cancelled'].indexOf(e.reason.error.code) >= 0
        )
          e.preventDefault()
      })

      this.send('connect')

    },
    send(type, data) {

      // console.log(type)

      const payload = {
        swaychat_social: 'server',
        type,
        data
      }
      let target = parent || opener
      target.postMessage(JSON.stringify(payload), '*');

    },
    listen(e) {

      if (!e.data ||
        typeof e.data != 'string' ||
        /swaychat_social/.test(e.data) == false
      ) return

      const payload = JSON.parse(e.data)
      // console.log(payload)

      if (payload.type == 'login' &&
        payload.data &&
        payload.data.network
      )
        hello(payload.data.network).login({
          scope: 'email'
        }).then(()=>{},(e)=>{})

      if (payload.type == 'logout' &&
        payload.data &&
        payload.data.network
      )
        hello(payload.data.network).logout().then(()=>{},(e)=>{})

    },
    login(auth) {

      hello(auth.network).api('me').then((r)=>{
        this.send('loggedIn', {
          network: auth.network,
          ...r
        })
      },(e)=>{})

    },
    logout(auth) {

      this.send('loggedOut', { network: auth.network })

    }
  }
}

</script>
